import React, { FC } from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';
import Box from '@mui/material/Box';
import { useTranslation } from "next-i18next";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';



interface IYoutubePlayerProps {
    videoId: string;
    width?: string | number;
    height?: string | number;
}

const YoutubePlayer: FC<IYoutubePlayerProps> = (props: IYoutubePlayerProps) => {
    const { videoId, width = '100%', height = '100%' } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


    const onPlayerReady: YouTubeProps['onReady'] = (event) => {
        // access to player in all event handlers via event.target
        // event.target.pauseVideo();
      }

    const opts: YouTubeProps['opts'] = {
        height: height,
        width: width,
        playerVars: {
          autoplay: 0,
          enablejsapi: 1,
          iv_load_policy:3,
          origin: t('appUrl')
        }
      };

    return (
        <Box sx={{ my: 2, backgroundColor:'#333333', height: fullScreen ? 'none' : height,  width: width }}>
            <YouTube videoId={videoId} opts={opts} onReady={onPlayerReady} />
            {/* <iframe id='ik_player_iframe' frameBorder='0' height={height} width={width} src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&origin=http://${t('appUrl')}`}>
            </iframe> */}
        </Box>
    );
}

export default YoutubePlayer;